<template>
  <div class="component-grade-post-list">
    <p class="text large bold dark">Order Transcript 寄送成绩单</p>
    <p class="text mt-20">
      我们很高兴可以为峰会校友提供成绩单的寄送服务。所有成绩单的寄送都需经由在线系统提出申请，并按要求填写一系列的信息。提交申请后，成绩单会进行专门的封存并邮寄到你指定的地点。<br /><br />

      正式成绩单将会在订购后的10个工作日内（不含周末、公共假期等节假日）寄出。成绩单寄送均使用顺丰快递，从2023年9月1日起寄送中国地区(含港澳台)
      的价格为每份成绩单（包含运费）60元，寄送海外地址价格为第一张证书400元（若同一地址需多份，每份另加60元）。一般来说，国内的地址会在寄出后一周内送达，国外的地址会在15-20天左右送达。由于无法直接控制快递公司的寄送速度，有时也会出现预计时间长的情况，敬请体谅。<br /><br />

      对于你的成绩单寄送有任何问题，可以通过<a href="mailto:apply@hsylc.cn" target="_blank" class="link">apply@hsylc.cn</a>联系我们。
    </p>
    <p class="big bold dark mt-30">我的订单</p>
    <ElTable class="mt-10 table-wrap" :data="orderData">
      <ElTableColumn prop="time" label="日期" width="180"></ElTableColumn>
      <ElTableColumn prop="feeStr" label="金额"></ElTableColumn>
      <ElTableColumn prop="paidState" label="支付状态"></ElTableColumn>
      <ElTableColumn prop="expressState" label="寄送状态"></ElTableColumn>
      <ElTableColumn width="120">
        <template slot-scope="scope">
          <Button class="btn-detail" size="small" skin="grey" v-if="scope.row.isPaid" @click="handleClick(scope.row.id)">查看详情</Button>
          <Button class="btn-detail" size="small" v-else @click="handleClick(scope.row.id)">支付订单</Button>
        </template>
      </ElTableColumn>
    </ElTable>
    <a @click="resetOrderData" class="mt-10 reload link text red bold">刷新</a>
    <Button class="btn-submit mt-30" @click="handleClick()">新建订单</Button>
  </div>
</template>
<script>
import Button from 'components/form/Button';
import { Api, Codes } from 'api';
import { Table as ElTable, TableColumn as ElTableColumn } from 'element-ui';
import Moment from 'moment';
export default {
  name: 'List',
  components: {
    ElTable,
    ElTableColumn,
    Button
  },
  computed: {
    orderData() {
      return this.orders.map(item => ({
        ...item,
        time: Moment(item.updated_at || item.created_at).format('YYYY-MM-DD HH:mm:ss'),
        feeStr: `${item.fee}元`,
        isPaid: !!item.paid_at,
        paidState: item.paid_at ? '已支付' : '未支付',
        expressState: item.express_no ? '已发货' : '未发货'
      }));
    }
  },
  data: () => ({
    orders: []
  }),
  async created() {
    await this.resetOrderData();
  },
  methods: {
    async resetOrderData() {
      this.$loading.show();
      let res = await Api.get.getStudentTranscriptDeliveryOrders();
      if (res.status === Codes.SUCCESS && res.data?.orders?.length) {
        this.orders = res.data.orders;
      }
      this.$loading.hide();
    },
    reload() {
      window.location.reload();
    },
    handleClick(id) {
      let href = '/student/manage/grade/post/detail';
      if (id) {
        href += '/' + id;
      }
      this.$windowOpen(href);
    }
  }
};
</script>
